import { createFileRoute, redirect, useNavigate, useSearch } from '@tanstack/react-router'
import { PerformancePage } from '@unsw/features/admin-dashboard'
import type { Granularity, UsageSearchParams } from '@unsw/features/admin-dashboard'
import { useSidebar } from '@unsw/hooks'
import { useIsMobile } from '@unsw/hooks'
import { getUserRole } from '@unsw/hooks'

export const Route = createFileRoute('/dashboard/performance')({
  beforeLoad: () => {
    const { isAdmin } = getUserRole()
    if (!isAdmin) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: PerformanceRoute,
  validateSearch: (search: Record<string, unknown>): UsageSearchParams => ({
    years: search.years as string | undefined,
    cohorts: search.cohorts as string | undefined,
    teacherIds: search.teacherIds as string | undefined,
    studentIds: search.studentIds as string | undefined,
    dateFrom: search.dateFrom as string | undefined,
    dateTo: search.dateTo as string | undefined,
    granularity: search.granularity as Granularity | undefined,
  }),
})

function PerformanceRoute() {
  const navigate = useNavigate({ from: '/dashboard/performance' })
  const searchParams = useSearch({ from: '/dashboard/performance' })
  const isMobile = useIsMobile()
  const { sidebarCollapsed, toggleSidebar, closeSidebar } = useSidebar()

  const handleFilterChange = (newParams: Partial<UsageSearchParams>) => {
    navigate({
      search: (prev) => ({ ...prev, ...newParams }),
    })
  }

  return (
    <PerformancePage
      searchParams={searchParams}
      onFilterChange={handleFilterChange}
      isMobile={isMobile === true}
      sidebarCollapsed={sidebarCollapsed}
      onToggleSidebar={toggleSidebar}
      onCloseSidebar={closeSidebar}
    />
  )
}
